import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { KpiNotificationReducer } from './state';
import { ReportOverviewEffects } from './state/kpi-notification-settings.effect';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(
            'kpi-notification-settings',
            KpiNotificationReducer.kpiNotificationSettingsReducer,
            {
                initialState: KpiNotificationReducer.initialState,
            },
        ),
        EffectsModule.forFeature([ReportOverviewEffects]),
    ],
})
export class KpiNotificationSettingsModule {}
